import { Card } from '@tribeplatform/react-ui-kit/Card'

import { Payments } from './Payments'

export const PaymentsCard = () => {
  return (
    <Card>
      <Card.Header title="Payments" />
      <Card.Content>
        <Payments />
      </Card.Content>
    </Card>
  )
}
